<div
  *ngIf="flexSheetService.isUiReadyForRender === true"
  class="app-platform-tool-spreadsheet-editor-container"
>
  <mat-drawer-container>
    <mat-drawer
      *ngIf="this.selectedTab.tabData['LeftSideBar']"
      #sideLeftNav
      mode="side"
      [opened]="leftfootNoteOpened"
      [position]="'start'"
    >
      <app-foot-note-container
        *ngIf="flexSheetService.isRenderComplete"
        [selectedTab]="selectedTab"
        [magicLinkModel]="magicLinkModel"
        [invalidateSubject]="invalidateSubject"
      ></app-foot-note-container>
    </mat-drawer>
    <mat-drawer-content>
      <button
        *ngIf="this.selectedTab.tabData['LeftSideBar']"
        class="arrow-slider-btn"
        (click)="sideLeftNav.toggle(); sideBarToggled('Left')"
        mat-button
        [attr.data-cy]="leftfootNoteOpened ? 'footnote-left-slider-close' : 'footnote-left-slider-open'"
      >
        <svg
          matTooltip="Open"
          *ngIf="leftfootNoteOpened"
          version="1.1"
          class="default"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 13 73"
          enable-background="new 0 0 13 73"
          xml:space="preserve"
        >
          <g>
            <g>
              <path
                class="splitter-group-handle-border"
                d="M5.4,57.3c6.1-1.4,5.6-8.9,5.6-8.9V36.5V24.6c0,0,0.5-7.5-5.6-8.9C0,14.3,0,11,0,11v25.5V62 C0,61.9,0,58.6,5.4,57.3z"
              ></path>
              <path
                class="splitter-group-handle-bg"
                d="M4.8,55.8c5.3-1.3,4.8-7.1,4.8-7.1V36.5V24.4c0,0,0.5-5.9-4.8-7.1C0,16.1,0,13.9,0,13.9v22.6v22.4 C0,58.9,0,56.9,4.8,55.8z"
              ></path>
            </g>

            <polygon
              class="splitter-group-handle-triangle"
              fill="white"
              points="3,32.4 8.3,36.5 3,40.6 "
            ></polygon>
          </g>
        </svg>

        <svg
          matTooltip="Close"
          *ngIf="!leftfootNoteOpened"
          class="close"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 13 73"
          enable-background="new 0 0 13 73"
          xml:space="preserve"
        >
          <g>
            <g>
              <path
                class="splitter-group-handle-border"
                d="M5.4,57.3c6.1-1.4,5.6-8.9,5.6-8.9V36.5V24.6c0,0,0.5-7.5-5.6-8.9C0,14.3,0,11,0,11v25.5V62 C0,61.9,0,58.6,5.4,57.3z"
              ></path>
              <path
                class="splitter-group-handle-bg"
                d="M4.8,55.8c5.3-1.3,4.8-7.1,4.8-7.1V36.5V24.4c0,0,0.5-5.9-4.8-7.1C0,16.1,0,13.9,0,13.9v22.6v22.4 C0,58.9,0,56.9,4.8,55.8z"
              ></path>
            </g>

            <polygon
              class="splitter-group-handle-triangle"
              fill="white"
              points="3,32.4 8.3,36.5 3,40.6 	"
            ></polygon>
          </g>
        </svg>
      </button>
      <mat-tab-group
        [ngClass]="
          workbookGroupModels.length === 1 ? 'first-level-tab-header-hide' : ''
        "
        (selectedIndexChange)="onWorkbookGroupModelsChange($event, true)"
        [selectedIndex]="selectedWorkbookGroupModelsIndex"
        #tabGroup1
      >
        <mat-tab
          *ngFor="let workbookGroupModel of workbookGroupModels; let i = index"
        >
          <ng-template mat-tab-label>
            <span [attr.data-copilot]="'workbook-group-' + workbookGroupModel?.header">{{ workbookGroupModel?.header }}</span>
          </ng-template>
          <mat-tab-group
            #tabGroup2
            [ngClass]="
              workbookGroupModel.workbookModels.length === 1
                ? 'second-level-tab-header-hide'
                : ''
            "
            *ngIf="selectedWorkbookGroupModelsIndex == i && currentWorkbook"
            class="compact-tab-view m-t-20"
            (selectedIndexChange)="onWorkbookGroupModelsChange($event, false)"
            [selectedIndex]="selectedWorkbookIndex"
          >
            <mat-tab
              *ngFor="
                let workbook of workbookGroupModel.workbookModels;
                let j = index
              "
            >
              <ng-template mat-tab-label>
                <span [attr.data-copilot]="'workbook-' + workbook?.name">{{ workbook?.name }}</span>
              </ng-template>
              <app-workbook-container
                *ngIf="
                  selectedWorkbookIndex == j &&
                  currentWorkbook &&
                  worksheets &&
                  workbook.id === currentWorkbook.id
                "
              ></app-workbook-container>
              <div *ngIf="worksheets == null" class="w-p-100">
                <div data-cy="platform-tool-busy-screen-dual-ball"
                  class="busy-content w-p-100 flex flex-col flex-1-0-100">
                  <div class="text-container" style="width: 660px">
                    <img
                      src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/dual-ball-1s-200px.gif"
                      alt="Please wait"
                    />
                  </div>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </mat-tab>
      </mat-tab-group>
      <button
        class="arrow-slider-btn"
        *ngIf="this.selectedTab.tabData['RightSideBar']"
        (click)="sideRightNav.toggle(); sideBarToggled('Right')"
        mat-button
        [attr.data-cy]="rightfootNoteOpened ? 'footnote-right-slider-close' : 'footnote-right-slider-open'"
      >
        <svg
          matTooltip="Open"
          *ngIf="!rightfootNoteOpened"
          version="1.1"
          class="default"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 13 73"
          enable-background="new 0 0 13 73"
          xml:space="preserve"
        >
          <g>
            <g>
              <path
                fill="#1a232f"
                d="M5.4,57.3c6.1-1.4,5.6-8.9,5.6-8.9V36.5V24.6c0,0,0.5-7.5-5.6-8.9C0,14.3,0,11,0,11v25.5V62 C0,61.9,0,58.6,5.4,57.3z"
              ></path>
              <path
                fill="#1a232f"
                d="M4.8,55.8c5.3-1.3,4.8-7.1,4.8-7.1V36.5V24.4c0,0,0.5-5.9-4.8-7.1C0,16.1,0,13.9,0,13.9v22.6v22.4 C0,58.9,0,56.9,4.8,55.8z"
              ></path>
            </g>

            <polygon
              class="splitter-group-handle-triangle"
              fill="white"
              points="3,32.4 8.3,36.5 3,40.6 "
            ></polygon>
          </g>
        </svg>

        <svg
          matTooltip="Close"
          *ngIf="rightfootNoteOpened"
          class="close"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 13 73"
          enable-background="new 0 0 13 73"
          xml:space="preserve"
        >
          <g>
            <g>
              <path
                fill="#1a232f"
                d="M5.4,57.3c6.1-1.4,5.6-8.9,5.6-8.9V36.5V24.6c0,0,0.5-7.5-5.6-8.9C0,14.3,0,11,0,11v25.5V62 C0,61.9,0,58.6,5.4,57.3z"
              ></path>
              <path
                fill="#1a232f"
                d="M4.8,55.8c5.3-1.3,4.8-7.1,4.8-7.1V36.5V24.4c0,0,0.5-5.9-4.8-7.1C0,16.1,0,13.9,0,13.9v22.6v22.4 C0,58.9,0,56.9,4.8,55.8z"
              ></path>
            </g>

            <polygon
              class="splitter-group-handle-triangle"
              fill="white"
              points="3,32.4 8.3,36.5 3,40.6 	"
            ></polygon>
          </g>
        </svg>
      </button>
    </mat-drawer-content>

    <mat-drawer
      #sideRightNav
      mode="side"
      [opened]="rightfootNoteOpened"
      [position]="'end'"
    >
      <app-platform-tool-card-holder
        [handler]="handler"
        [invalidateSubject]="invalidateSubject"
        [magicLinkModel]="magicLinkModel"
        [cardHolder]="magicLinkModel.cardHolder"
        [selectedTab]="selectedTab"
      >
      </app-platform-tool-card-holder>
    </mat-drawer>
  </mat-drawer-container>
</div>
<div *ngIf="flexSheetService.isUiReadyForRender === false" class="w-p-100 flex justify-center items-center">
  <div class="busy-content w-p-100 flex flex-col flex-1-0-100">
    <particle-platform-tool-busy-screen
      [busyScreen]="busyScreenModel"
    ></particle-platform-tool-busy-screen>
  </div>
</div>
